import React from "react"
import clsx from "clsx"
import { FlexBox } from "@components/wrapper"
import { useField } from "formik"

export interface FormikTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputClassName?: string
  maxCharacter?: number
  minCharacter?: number
}

export const FormikTextArea: React.FC<FormikTextAreaProps> = ({
  minCharacter,
  maxCharacter = 300,
  className,
  inputClassName,
  name,
  ...props
}) => {
  const [field, meta] = useField(name ?? "")
  const errorText = meta.error
  const val = field.value as string

  let textAreaInfo

  switch (true) {
    case typeof errorText === "string" && errorText.length > 0:
      textAreaInfo = <small className="text-red">{errorText}</small>
      break
    case typeof minCharacter === "number":
      textAreaInfo = (
        <small className={clsx((minCharacter as number) > val.length && "text-red")}>
          Minimal {minCharacter ?? 0} Karakter
        </small>
      )
      break
    default:
      textAreaInfo = <small>Maksimal {maxCharacter ?? 0} Karakter</small>
      break
  }

  return (
    <div className={clsx("relative", className)}>
      <textarea
        {...field}
        {...props}
        maxLength={maxCharacter}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded w-full border-2 border-grey-ec sm:text-base text-sm",
          "focus:outline-none focus:shadow-outline",
          field.value && !errorText && "border-2 !border-green",
          errorText && "!border-red border"
        )}
      />
      <FlexBox justify="between" className="absolute -bottom-4 w-full">
        {textAreaInfo}
        <small>
          {maxCharacter
            ? `(${val?.length ?? 0}/${maxCharacter})`
            : `(${val?.length ?? 0} karakter)`}
        </small>
      </FlexBox>
    </div>
  )
}
